import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import VideoForm from "../../components/common/VideoForm";
import { createVideo } from "../../services/videoService";

export default function VideoCreatePage() {
  const nav = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    try {
      setSubmitting(true);
      // If your API generates ID, you can omit 'id' here:
      // const { id, ...payload } = data;
      await createVideo(data);
      alert("Video created successfully.");
      nav("/admin/videos");
    } catch (e) {
      alert(e.message || "Failed to create video");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h4 className="mb-0">Add Video</h4>
        <Link to="/admin/videos" className="btn btn-outline-secondary">Back to List</Link>
      </div>
      <VideoForm mode="create" onSubmit={handleSubmit} submitting={submitting} />
    </div>
  );
}
